import classNames from 'classnames';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { VolunteerLayout } from '@layouts/VolunteerLayout/VolunteerLayout';
import { Container } from '@layouts/Container/Container';
import { ProfileData } from '@components/volunteers/organisms/ProfileData/ProfileData';
import { EventsAvailableCard } from '@components/volunteers/organisms/EventsAvailableCard/EventsAvailableCard';
import { RegistrationsCard } from '@components/volunteers/organisms/RegistrationsCard/RegistrationsCard';
import { AchievementsCard } from '@components/volunteers/organisms/AchievementsCard/AchievementsCard';
import { useUserContext } from '@contexts/UserContext';

import styles from './ProfilePage.module.scss';

export default function ProfileView() {
  const { user } = useUserContext();
  const navigate = useNavigate();

  useEffect(() => {
    if (!user?.profile) {
      navigate('/user/create-profile');
    }
  }, [user, navigate]);

  return (
    <VolunteerLayout>
      <div className={styles.pageContainer}>
        <Container className={styles.container}>
          <div className={styles.profileContainer}>
            <div
              className={classNames(styles.cardConatiner, styles.profileData)}
            >
              <ProfileData />
            </div>
            <div
              className={classNames(
                styles.cardConatiner,
                styles.registrationsCard
              )}
            >
              <RegistrationsCard />
            </div>
            <EventsAvailableCard className={styles.eventsAvailableCard} />
            <div
              className={classNames(
                styles.cardConatiner,
                styles.achievementsCard
              )}
            >
              <AchievementsCard />
            </div>
          </div>
        </Container>
      </div>
    </VolunteerLayout>
  );
}
